import { memo } from '../../lib/teact/teact';

import useLang from '../../hooks/useLang';
import useLastCallback from '../../hooks/useLastCallback';

import Button from '../ui/Button';
import Modal from '../ui/Modal';

import styles from './TermsModal.module.scss';

type OwnProps = {
  isOpen: boolean;
  onAgree: NoneToVoidFunction;
  onDecline: NoneToVoidFunction;
};

const PLATFORM_TERMS_URL = 'https://run.ceo/legal/platform-terms';
const ORG_TERMS_URL = 'https://run.ceo/legal/customer-agreement';

const TermsModal = ({
  isOpen, onAgree, onDecline,
}: OwnProps) => {
  const lang = useLang();

  const handleAgree = useLastCallback(() => {
    onAgree();
  });

  const handleDecline = useLastCallback(() => {
    onDecline();
  });

  return (
    <Modal isSlim isOpen={isOpen} onClose={handleDecline}>
      <div className={styles.container} dir={lang.isRtl ? 'rtl' : undefined}>
        <div className={styles.icon}>📋</div>
        <h2 className={styles.header}>
          {lang('RunTermsHeader')}
        </h2>
        <div className={styles.content}>
          {lang('RunTermsText')}
        </div>
        <div className={styles.links}>
          <a href={PLATFORM_TERMS_URL} target="_blank" rel="noreferrer" className={styles.link}>
            {lang('RunTermsPlatformLink')}
          </a>
          <a href={ORG_TERMS_URL} target="_blank" rel="noreferrer" className={styles.link}>
            {lang('RunTermsOrgLink')}
          </a>
        </div>
        <Button
          onClick={handleAgree}
          className={styles.agreeButton}
        >
          {lang('RunTermsAgree')}
        </Button>
        <Button
          color="danger"
          isText
          onClick={handleDecline}
          className={styles.declineButton}
        >
          {lang('RunTermsDecline')}
        </Button>
      </div>
    </Modal>
  );
};

export default memo(TermsModal);
